import script from "./FilterInterface.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterInterface.vue?vue&type=script&setup=true&lang=ts"

import "./FilterInterface.vue?vue&type=style&index=0&id=8dd7de7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8dd7de7a"]])

export default __exports__